import { create } from "zustand";
import produce from "immer";
import { sendHeartbeat } from "../services/presence";

export const usePresenceStore = create((set) => ({
  users: [],
  count: 0,
  heartbeat: async () => {
    try {
      const data = await sendHeartbeat();
      set(
        produce((draft) => {
          draft.users = data.users;
          draft.count = data.count;
        }),
      );
    } catch {
      // silent — best-effort
    }
  },
}));
